import { useMemo } from "react";
import {
	Anchor,
	TrafficCone,
	Waves,
	Thermometer,
	Mountain,
	Flame,
	TreePine,
	Home,
	CloudFog,
	Eye,
	Zap,
	Ellipsis,
} from "lucide-react";

export function useAlertCreationTemplateMessages(t: (key: React.Key) => string) {
	const TEMPLATE_MESSAGES = useMemo(
		() =>
		({
			extreme_heat: {
				title: t("extremeHeatTitle"),
				description: t("extremeHeatDescription"),
				icon: Thermometer,
			},
			extreme_wind: {
				title: t("extremeWindTitle"),
				description: t("extremeWindDescription"),
				icon: TrafficCone,
			},
			extreme_rain: {
				title: t("extremeRainTitle"),
				description: t("extremeRainDescription"),
				icon: Waves,
			},
			landslide: {
				title: t("landslideTitle"),
				description: t("landslideDescription"),
				icon: Mountain,
			},
			wildfire: {
				title: t("wildfireTitle"),
				description: t("wildfireDescription"),
				icon: Flame,
			},
			tree_fall: {
				title: t("treeFallTitle"),
				description: t("treeFallDescription"),
				icon: TreePine,
			},
			roof_damage: {
				title: t("roofDamageTitle"),
				description: t("roofDamageDescription"),
				icon: Home,
			},
			rough_sea: {
				title: t("roughSeaTitle"),
				description: t("roughSeaDescription"),
				icon: Anchor,
			},
			fog: {
				title: t("fogTitle"),
				description: t("fogDescription"),
				icon: CloudFog,
			},
			low_visibility: {
				title: t("lowVisibilityTitle"),
				description: t("lowVisibilityDescription"),
				icon: Eye,
			},
			lightning_storm: {
				title: t("lightningStormTitle"),
				description: t("lightningStormDescription"),
				icon: Zap,
			},
			no_category: {
				title: t("noCategoryTitle"),
				description: t("noCategoryDescription"),
				icon: Ellipsis,
			},
			port_closure: {
				title: t("portClosureTitle"),
				description: t("potentialSuspension"),
				icon: Anchor,
			},
		} as Record<string, { title: string; description: string; icon: any }>),
		[t]
	);

	return TEMPLATE_MESSAGES;
}
